import { useSelector } from 'react-redux';

import { getCompanyConfig } from '../../../redux/Company/selectors';

export function useLogoPath() {
  const companyConfiguration = useSelector(getCompanyConfig);
  const logoPath = companyConfiguration?.style?.['logo-path'];
  if (logoPath) {
    return `/s3${logoPath}`;
  }
}
